import {
  protectedDelete,
  protectedDeleteWithBody,
  protectedGet,
  protectedPost,
} from "./restUtil";
import { StudentStatus } from "./students";

import * as _ from "underscore";

export function getFavoritesForInstructor(args, onSuccess, onError) {
  if (args === undefined) {
    args = {
      student_status: Object.values(StudentStatus)
        .filter(status => status !== StudentStatus.GRADUATED)
        .join(","),
    };
  }
  return protectedGet(
    "/students/favorites?sort=name",
    args,
    resp => {
      if (!resp || !resp.list) {
        return onError && onError("invalid response structure");
      }

      // TODO change the server to return required response structure
      const students = [];
      _.each(resp.list, s => {
        students.push({
          id: s.id,
          status: s.status,
          profile: {
            email: s.email,
            first_name: s.first_name,
            last_name: s.last_name,
            timezone: {
              id: s.timezone.id,
              utc_offset: s.timezone.utc_offset,
            },
            address: {
              city: s.city,
              country: s.country,
            },
          },
          student: {
            number_of_lessons: s.number_of_lessons,
            status: s.student.status,
          },
          primary_instructor: s.primary_instructor,
        });
      });

      return onSuccess({ list: students });
    },
    onError
  );
}

export const isFavoriteInstructor = studentId => (onSuccess, onError) => {
  return protectedGet(
    "/students/favorites",
    undefined,
    resp => {
      return isFavorite(resp, studentId, onSuccess, onError);
    },
    onError
  );
};

export const isFavoriteStudent = instructorId => (onSuccess, onError) => {
  return protectedGet(
    "/instructors/favorites",
    undefined,
    resp => {
      return isFavorite(resp, instructorId, onSuccess, onError);
    },
    onError
  );
};

function isFavorite(resp, id, onSuccess, onError) {
  if (!resp || !resp.list) {
    return onError && onError("invalid response structure");
  }

  const favorite = _.findWhere(resp.list, { id: id });

  if (onSuccess) {
    return onSuccess(favorite !== undefined);
  }
}

export const removeStudentFromFavorites = (studentId, onSuccess, onError) => {
  return protectedDeleteWithBody(
    "/students/favorites",
    {
      id: studentId,
    },
    onSuccess,
    onError
  );
};

export const addFavouriteCourse = (id, onSuccess, onError) => {
  return protectedPost(`/library/${id}/favorite`, {}, onSuccess, onError);
};
export const removeFavouriteCourse = (id, onSuccess, onError) => {
  return protectedDelete(`/library/${id}/favorite`, {}, onSuccess, onError);
};
